import { Environment, getEnvironment } from './environmentService'

const getUrl = (environment: Environment): string => {
  switch (environment) {
    case Environment.Local:
      return '/'
    case Environment.Int:
      return 'https://creditcheck.int.igssolarpower.com/'
    case Environment.Dev:
      return 'https://creditcheck.dev.igssolarpower.com/'
    case Environment.Qa:
      return 'https://creditcheck.qa.igssolarpower.com/'
    case Environment.Training:
      return 'https://creditcheck.trn.igssolarpower.com/'
    case Environment.Con1:
      return 'https://creditcheck.con1.igssolarpower.com/'
    case Environment.Con2:
      return 'https://creditcheck.con2.igssolarpower.com/'
    case Environment.Con3:
      return 'https://creditcheck.con3.igssolarpower.com/'
    case Environment.Prod:
      return 'https://creditcheck.igssolarpower.com/'
    default:
      return ''
  }
}

export const getBaseUrl = (): string => getUrl(getEnvironment())

export const getAngularBaseUrl = (): string => `${getBaseUrl()}/#/`



// WEBPACK FOOTER //
// ./src/baseUrlService.ts